export const FOCUSABLE_ENTITIES = [
	'wp_template_part',
	'wp_navigation',
	'wp_block',
];
